import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Field } from 'react-final-form';
import { FieldArray } from 'react-final-form-arrays';
import { Button, Typography, Grid } from '@material-ui/core';
import FormImageField from '../../form/FormImageField';

const BoardPostGalleryFormItem = ({ t, disabled }) => (
  <FieldArray name="images">
    {({ fields, meta: { error } }) => (
      <React.Fragment>
        {error && typeof error === 'string' ? <Typography color="error" variant="caption">{error}</Typography> : null}
        {fields.map((fieldName, index) => (
          <Grid key={index} container direction="row" spacing={1} alignItems="center">
            <Grid item>
              <div>
                <Field
                  type="file"
                  name={`${fieldName}file`}
                  component={FormImageField}
                />
              </div>
            </Grid>
            <Grid item>
              <Button size="small" onClick={() => fields.remove(index)} disabled={disabled}>{t('surveyDetails.detailsTab.removeButton')}</Button>
            </Grid>
          </Grid>
        ))}
        <Button
          style={{marginTop: 16}}
          variant="outlined"
          size="small"
          onClick={() => fields.push('')}
          disabled={disabled}
        >
          {t('boardThreadDetails.form.addImageButton')}
        </Button>
      </React.Fragment>
    )}
  </FieldArray>
);

BoardPostGalleryFormItem.propTypes = {
  t: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default translate()(BoardPostGalleryFormItem);



// WEBPACK FOOTER //
// ./src/components/consultationSurveys/board/BoardPostGalleryFormItem.js